import type { ApprovalChain } from '../approval-chain.model';

export const CAVEAT_REGISTRATION_CHAIN: ApprovalChain = {
  id: 'caveat-registration',
  label: 'Caveat Registration',
  applicationTypes: ['CAVEAT_REGISTRATION'],
  steps: [
    { role: 'FINANCE_OFFICER', action: 'Approve Payment', from: ['SUBMITTED', 'RESUBMITTED'], to: 'FINANCE_APPROVED' },
    { role: 'EXAMINER', action: 'Recommend', from: ['FINANCE_APPROVED', 'SUBMITTED', 'RESUBMITTED', 'PENDING_REVIEW'], to: 'EXAMINER_RECOMMENDED' },
    { role: 'REGISTRAR', action: 'Approve', from: ['EXAMINER_RECOMMENDED'], to: 'APPROVED' },
  ],
};
